import React from 'react';
import { observer, inject } from 'mobx-react';
import { Theme } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { WithTranslation } from 'react-i18next';

import { Services } from 'helpers/constants/Services';
import { WizardModel, WizardStep } from 'models/kiosk/WizardModel';
import { withTranslation } from 'react-i18next';
import { StoreModel } from 'models/Index';
import { StepComponents } from 'containers/common';

export interface PaymentKioskPageProps
    extends WithStyles<typeof styles>,
        WithTranslation {}
export interface PaymentKioskPagePropsInjected extends PaymentKioskPageProps {
    Store: StoreModel;
    wizard: WizardModel;
}

const styles = (theme: Theme) =>
    createStyles({
        body: {
            height: '75vh',
            overflow: 'auto',
        },
    });

@inject(Services.STORE, Services.PAYMENT_WIZARD)
@observer
class PaymentKioskPage extends React.Component<PaymentKioskPageProps> {
    render() {
        const { classes, wizard } = this.props as PaymentKioskPagePropsInjected;
        const stepKey = wizard.currentStep as keyof typeof WizardStep; 
        return (
            <div>
                <div className={classes.body}>
                    {StepComponents[stepKey]}
                </div>
            </div>
        );
    }
}

export default withTranslation()(withStyles(styles)(PaymentKioskPage));
